export { CollectFeatureFiles } from './src/lib/feature-collector';